// extracted by mini-css-extract-plugin
export default {"adminText":"Admin_adminText__qoftb","adminContainer":"Admin_adminContainer__Wr0st"};